import {IX3_WF_EXTENSION_KEYS} from '@packages/systems/ix3-wf-plugins/shared';

export const IX3_TIMELINE_HEIGHT = 190;
export const IX3_TIMELINE_HEIGHT_MIN = 120;
export const IX3_TIMELINE_HEIGHT_MAX = 360;
export const IX3_TIMELINE_PLAYBAR_TIME_LINE_HEIGHT = 4;
export const IX3_TIMELINE_PLAYBAR_HEIGHT =
  48 + IX3_TIMELINE_PLAYBAR_TIME_LINE_HEIGHT;

export const enum ActionViewState {
  // Editing actions
  ActionEdit = 'MULTI_ACTION_EDIT', // Editing a specific action in multi-action mode

  // Action Add
  ActionMain = 'ACTION_MAIN',
}

/**
 * Default animation properties for new actions, showing the most common
 * properties.
 *
 * @see https://webflow.atlassian.net/browse/GSAP-185
 */
export const IX3_ACTION_ANIMATION_PROPS_COMMON = {
  opacity: null,
  x: null,
  y: null,
  scale: null,
} as const;

export const IX3_ACTION_ANIMATION_PROPS = {
  [IX3_WF_EXTENSION_KEYS.TRANSFORM]: IX3_ACTION_ANIMATION_PROPS_COMMON,
} as const;

/**
 * Default duration for new custom animation actions.
 * This is the duration applied when creating a new action.
 */
export const IX3_ACTION_DURATION = 0.3;
export const IX3_ACTION_DURATION_MEDIUM = 0.5;
export const IX3_ACTION_DURATION_DRAMATIC = 1;

/**
 * Hard cap on user-managed timeline groups per interaction. Decoupled
 * from `triggers.length`; orphan groups (no trigger assigned) are a
 * legal authoring state — the trigger popover's "Assign" dropdown lets
 * users link them later.
 */
export const IX3_MAX_TIMELINE_GROUPS = 5;

/**
 * Write-path count caps shared by DE + MCP (DSYS-7212 / Gap 8). Timelines
 * reuse `IX3_MAX_TIMELINE_GROUPS`; the rest are guardrails above realistic
 * panel authoring so pathological payloads stay bounded. Schema mirrors
 * these numbers in `designerInvariants` (drift-tested) because schema
 * cannot import this package.
 */
export const IX3_MAX_TRIGGERS_PER_INTERACTION = 20;
export const IX3_MAX_ACTIONS_PER_TIMELINE = 200;
export const IX3_MAX_TARGETS_PER_ACTION = 20;
